function ReceiverListController($scope, $q, receiverService){
    let promises = [];
    $scope.receivers = [];
    $scope.filter = {"BRAZIL": true, "INDIA": true, "CHINA": true};

    promises.push(receiverService.find({}));

    Promise.all(promises)
    .then(results => {
        $scope.receivers = results[0];
    })

    // functions
    function applyFilter(item){
        let noFilter = (filterObj) => Object.keys(filterObj).every(key => !filterObj[key])
        let display =  $scope.filter[_.toUpper(item.pais)] || noFilter($scope.filter);
        return display;
    }

    $scope.applyFilter = applyFilter;
    $scope.get = receiverService.get;

}

ReceiverListController.$inject = ['$scope','$q','receiverService']

app.controller('ReceiverListController', ReceiverListController)
